export default "__VITE_ASSET__Be$WB_w2__"